<div style="min-height: 500px;">
    <div class="p-2" mat-dialog-title>
        Add Existing {{label}}
    </div>
    <div mat-dialog-content class="mat-typography" style="min-height: 364px;">
        <form>
            <mat-form-field [hidden]="!!selectedProfile" [formGroup]="profileFormGroup" matTooltip="Enter 3 words to find profile">
                <mat-label>{{label}}</mat-label>
                <input matInput [placeholder]="placeholder ? placeholder : ((findItemByKey(tooltipProp, 'displayName') ?? 'Display Name')
                    + ' or '
                    + (findItemByKey(tooltipProp, 'realName') ?? 'Real Name'))" #myInput
                    formControlName="profileFormInput" [matAutocomplete]="autocomplete" [disabled]="loading"
                    [nbSpinner]="loading" (input)="rememberSearchInput(myInput.value)">
                <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayProfile"
                    (optionSelected)="showSelectedProfile($event.option.value)"
                    (opened)="onAutocompletePanelOpened()"
                    (closed)="onAutocompletePanelClosed()">
                    <mat-option *ngIf="showVendorRoles" [value]="'CREATE_NEW_CLIENT'"
                        class="multiline-mat-option">
                        <mat-icon color="primary">add</mat-icon>
                        <strong>Add new client</strong>
                    </mat-option>
                    <mat-option *ngIf="loading && profileList.length === 0" [nbSpinner]="loading" [disabled]="true"></mat-option>
                    <ng-container *ngIf="firstSuggest && profileFormGroup.controls.profileFormInput.value < 3">
                        <mat-option style="height: 35px !important;" [disabled]="true">We found {{searchArray.length}}
                            results
                            recently <b style="color:green">updated</b>.</mat-option>
                        <mat-option *ngFor="let item of searchArray"
                            [value]="showVendorRoles ? item : item.displayName"
                            class="multiline-mat-option">
                            <div class="limit-line" style="--line: 1">
                                {{item.displayName}} {{item?.realName ? ' - ' + item?.realName : ''}}
                            </div>
                            <div *ngIf="item.actGroupId"><i class="text-muted">Has relationship</i></div>
                        </mat-option>
                    </ng-container>
                    <mat-option *ngFor="let profile of profileList"
                        [value]="showVendorRoles ? profile : profile.displayName"
                        [disabled]="isNotFoundProfile(profile)"
                        class="multiline-mat-option">
                        <div class="limit-line" style="--line: 1">
                            {{profile.displayName}} {{profile?.realName ? ' - ' + profile?.realName : ''}}
                        </div>
                        <div *ngIf="profile.actGroupId"><i class="text-muted">Has relationship</i></div>
                    </mat-option>
                    <mat-option *ngIf="lazyLoading" [disabled]="true" style="text-align: center; height: 35px !important;">
                        <span [nbSpinner]="true" nbSpinnerSize="small"></span> Loading more...
                    </mat-option>
                    <mat-option *ngIf="isProfile && lazyHasMore && !lazyLoading" [disabled]="true"
                        style="height: 35px !important; font-style: italic; color: #888;">
                        Scroll down to load more results...
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </form>

        <section *ngIf="showVendorRoles && selectedProfile" class="participation-section"
            [formGroup]="profileFormGroup">
            <div class="section-heading">
                <h3>Proposal participation</h3>
                <p>Choose the client's responsibilities for this proposal.</p>
            </div>

            <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Roles</mat-label>
                <mat-select formControlName="roles" multiple placeholder="No Role">
                    <mat-option *ngFor="let role of vendorRoleOptions" [value]="role.value">
                        {{role.label}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="signer-control"
                [class.signer-control--active]="profileFormGroup.controls.isPrimary.value">
                <div class="signer-control__icon" aria-hidden="true">
                    <mat-icon>draw</mat-icon>
                </div>
                <div class="signer-control__copy">
                    <strong>Contract signer</strong>
                    <span>This client signs the contract for the proposal.</span>
                </div>
                <mat-slide-toggle formControlName="isPrimary" aria-label="Contract signer"
                    (change)="onSignerChanged($event.checked)"></mat-slide-toggle>
            </div>
        </section>

        <div class="h6" *ngIf="!showVendorRoles || selectedProfile">
            {{label}} Information
        </div>
        <div *ngIf="!isProfile; else profileRelationship">
            <div *ngIf="selectedProfile != undefined && selectedProfile != null">
                <app-producer-profile-info [profile]="selectedProfile" [tooltipProp]="tooltipProp">
                </app-producer-profile-info>
            </div>
        </div>

    </div>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="warn" (click)="closeDialog(false)" [disabled]="saveLoading">
            Cancel
        </button>
        <button mat-raised-button color="primary" [nbSpinner]="saveLoading" (click)="saveProfile()"
            [disabled]="saveLoading || !selectedProfile || id == selectedProfile?.profileId">
            Add
        </button>
    </mat-dialog-actions>
</div>
<ng-template #profileRelationship>
    <div *ngIf="selectedProfile != undefined && selectedProfile != null">
        <ng-container [ngSwitch]="selectedProfile.typeName">
            <ng-container *ngSwitchCase="'SALEACCOUNT'">
                <app-sale-account-relationship-card [accountLabel]="label" [model]="selectedProfile" [id]="id" [isRemovable]="true"
                    (removeAccount)="clearSaleAccount()">
                </app-sale-account-relationship-card>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <app-profile-relationship-info [profile]="selectedProfile" [tooltipProp]="tooltipProp">
                </app-profile-relationship-info>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
